// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3BpT5","productName":"Table_productName__2Itw8"};